module.exports = __webpack_public_path__ + "static/media/42_RamonaKamminski_webfinal.d9ad408c.jpg";